import { lazy, Suspense } from "react";
import { Skeleton } from "@mui/material";

const MachinePositionsCard = lazy(() => import("./MachinePositionsCard").then(m => ({ default: m.MachinePositionsCard })));

export const LazyMachinePositionsCard: React.FC = () => (
  <Suspense fallback={(
    <div className="w-full h-full p-3">
      <Skeleton animation="wave" variant="rounded" width="100%" height="100%" className="!bg-theme-table-heading" />
    </div>
  )}>
    <MachinePositionsCard />
  </Suspense>
);
